import { IdPersistence } from "../../constants/IdPersistence";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { EventType } from "../balancing/types/BalancingCore";
import { IdBigCharacter } from "../generic/big-character/IdBigCharacter";
import { IdIcon } from "../generic/icon/IdIcon";
import { IdTournamentProgression } from "./IdTournamentProgression";
export var mapFullPromotionDemotion = new Map([
    [
        EventType.PlayerLeague,
        new Map([
            [
                IdTournamentProgression.Promoted,
                {
                    characterId: IdBigCharacter.TessaHappy,
                    descriptionId: IdLoca.tournamentDialogPlayerPromotion,
                    idIcon: IdIcon.LeaguePromotedIcn,
                    persistenceKey: IdPersistence.PlayerLeaguePreviousRanking,
                    shouldMirrorCharacterX: true,
                    titleId: IdLoca.tournamentRewardPlayerTitle,
                },
            ],
            [
                IdTournamentProgression.Demoted,
                {
                    characterId: IdBigCharacter.BigCharacter_Lester,
                    descriptionId: IdLoca.tournamentDialogPlayerDemotion,
                    idIcon: IdIcon.LeagueDemotedIcn,
                    persistenceKey: IdPersistence.PlayerLeaguePreviousRanking,
                    shouldMirrorCharacterX: false,
                    titleId: IdLoca.tournamentRewardPlayerTitle,
                },
            ],
        ]),
    ],
    [
        EventType.CoopLeague,
        new Map([
            [
                IdTournamentProgression.Promoted,
                {
                    characterId: IdBigCharacter.TessaHappy,
                    descriptionId: IdLoca.tournamentDialogCoopPromotion,
                    idIcon: IdIcon.LeaguePromotedIcn,
                    persistenceKey: IdPersistence.CoopPreviousRanking,
                    shouldMirrorCharacterX: true,
                    titleId: IdLoca.tournamentRewardCoopTitle,
                },
            ],
            [
                IdTournamentProgression.Demoted,
                {
                    characterId: IdBigCharacter.BigCharacter_Lester,
                    descriptionId: IdLoca.tournamentDialogCoopDemotion,
                    idIcon: IdIcon.LeagueDemotedIcn,
                    persistenceKey: IdPersistence.CoopPreviousRanking,
                    shouldMirrorCharacterX: false,
                    titleId: IdLoca.tournamentRewardCoopTitle,
                },
            ],
        ]),
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/mapFullPromotionDemotion.ts
// module id = 2954
// module chunks = 3